export const certificatelistMenuRouter = [{
  path: 'certificate/list',
  icon: ' iconfont iconcertificate',
  name: 'finishCertificate',
  title: '竣工合格证',
  component: () => import('@/views/gip/certificate/list.vue')
}]



// WEBPACK FOOTER //
// ./src/router/certificate/certificatelist.js